import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker from 'react-datepicker';
import ReactCrop from 'react-image-crop';
import api from '../../services/api';

import Select from '../../components/Select';
import TextArea from '../../components/TextArea';
import Loading from '../../components/Loading';
import { Container, ButtonPanel } from './styles';
import 'react-image-crop/dist/ReactCrop.css';
import Input from '../../components/Input';

export default class AddPost extends Component {
  state = {
    alert: {},
    content_kind: 'image',
    crop: {
      aspect: 0.56,
      width: 360,
      x: 0,
      y: 0,
    },
    description: '',
    event_id: null,
    events: [],
    expired_at: null,
    expired_after: 8,
    kind: 'stories',
    published_at: null,
    schedule: false,
    showAlert: false,
    loading: true,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  };

  componentDidMount() {
    this.loadEvents();
    this.setState({ expired_at: moment().add(moment.duration('08:00:00')) });
  }

  onSelectImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => this.setState({ imageSrc: reader.result }));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onSelectVideo = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ videoSrc: e.target.files[0] });
    }
  };

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;

    const { crop } = this.state;

    if (crop.aspect && crop.height && crop.width) {
      this.setState({
        crop: { ...crop, height: null },
      });
    } else {
      this.makeClientCrop(crop, pixelCrop);
    }
    this.setState(
      {
        alert: {
          title: 'Posicione e corte a imagem',
          type: 'info',
          messages: ['Clique em cima da imagem quando estiver na posição correta.'],
          onConfirm: () => this.closeAlert(),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = (crop) => {
    this.setState({ crop });
  };

  getCroppedImg(image, pixelCrop) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
        this.setState({ croppedImage: this.blobToFile(blob, 'cover.jpg') });
      }, 'image/jpeg');
    });
  }

  blobToFile = (theBlob, fileName) => {
    const blob = theBlob;
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return theBlob;
  };

  loadEvents = async () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const eventId = urlParams.get('event_id');

    try {
      const { data } = await api.get('events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const events = data.events
        .filter(event => event.status === 'active')
        .map(event => ({ value: event.id, text: event.name }));

      this.setState({
        events,
      });

      if (eventId) {
        this.setState({ event_id: eventId });
      }
      this.setState({ loading: false });
    } catch (err) {
      const { errors: messages } = err.response.data;
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleSubmit = async (e) => {
    const {
      content_kind,
      croppedImage,
      description,
      event_id,
      expired_at,
      kind,
      published_at,
      videoSrc,
    } = this.state;

    e.preventDefault();

    if (!event_id) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Selecione o evento.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } else {
      this.setState({ loading: true });
      try {
        const formData = new FormData();
        const formatedPublishedAt = published_at ? published_at.format() : null;
        const formatedExpiredAt = expired_at.format();
        if (content_kind === 'image') {
          formData.append('image', croppedImage);
        } else {
          formData.append('video', videoSrc);
        }
        if (kind === 'feed') {
          formData.append('description', description);
        }
        formData.append('content_kind', content_kind);
        formData.append('event_id', event_id);
        formData.append('expired_at', formatedExpiredAt);
        formData.append('kind', kind);
        formData.append('published_at', formatedPublishedAt);

        const res = await api.post('posts', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
          },
        });
        this.props.history.push(`/panel/posts/${res.data.id}`);
      } catch (err) {
        this.setState({ loading: false });
        const messages = err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors
          : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
        this.setState(
          {
            alert: {
              title: 'Erro',
              type: 'danger',
              messages,
              onConfirm: () => this.closeAlert(),
            },
          },
          () => {
            this.openAlert();
          },
        );
      }
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeKind = (e) => {
    const cropProportion = e.target.value === 'stories' ? 0.56 : 1;
    this.setState({
      crop: { ...this.state.crop, aspect: cropProportion },
      kind: e.target.value,
    });
  };

  handleChangeContentKind = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      croppedImage: null,
      croppedImageUrl: null,
      imageSrc: null,
      videoSrc: null,
    });
  };

  handleChangeSchedule = (e) => {
    const published_at = e.target.value === 'schedule' ? moment() : null;
    this.setState({
      published_at,
      schedule: e.target.value === 'schedule',
    }, () => {
      this.updateExpiredAt();
    });
  };

  handleChangePublishedAt = (date) => {
    this.setState({
      published_at: date,
    }, () => {
      this.updateExpiredAt();
    });
  };

  handleChangeExpiredAfter = (e) => {
    this.setState({
      expired_after: e.target.value,
    }, () => {
      this.updateExpiredAt();
    });
  };

  updateExpiredAt = () => {
    const { expired_after, published_at } = this.state;
    const publishing_date = published_at ? moment(published_at) : moment();
    const expiredAfterObject = moment.duration(`${expired_after}:00:00`);
    const expired_at = publishing_date.add(expiredAfterObject);
    this.setState({
      expired_at,
    });
  }

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
    });
  };

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, pixelCrop, 'newFile.jpeg');
      this.setState({ croppedImageUrl });
    }
  }

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      content_kind,
      crop,
      croppedImageUrl,
      description,
      event_id,
      events,
      expired_after,
      imageSrc,
      kind,
      loading,
      published_at,
      schedule,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <Container>
          <h1 className="page-title">Criar publicação</h1>
          <div className="box">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-12">
                  <div className="form-wrapper">
                    <div className="field-group radio-group">
                      <span className="field-title">Data de publicação:</span>
                      <input
                        type="radio"
                        name="schedule-options"
                        onChange={this.handleChangeSchedule}
                        value="publish"
                        defaultChecked
                      />{' '}
                      Publicar imediatamente
                      <br />
                      <input
                        type="radio"
                        name="schedule-options"
                        onChange={this.handleChangeSchedule}
                        value="schedule"
                      />{' '}
                      Agendar
                      {schedule && (
                        <Fragment>
                          <br />
                          <br />
                          <DatePicker
                            selected={published_at}
                            onChange={this.handleChangePublishedAt}
                            placeholderText="Data de publicação"
                            dateFormat="DD/MM/YYYY, HH:mm[h]"
                            minDate={moment()}
                            timeFormat="HH:mm"
                            timeCaption="Horário"
                            showTimeSelect
                            locale="pt-br"
                          />
                        </Fragment>
                      )}
                    </div>
                    <div className="field-group radio-group">
                      <span className="field-title">Expirar post após quantas horas?</span>
                      <span className="desc">Período limite para divulgador compartilhar a publicação</span>
                      <Input
                        type="number"
                        name="expired_after"
                        value={expired_after}
                        onChange={this.handleChangeExpiredAfter}
                        min="1"
                        max="24"
                      />
                    </div>
                    <div className="field-group">
                      <span className="field-title">Formato do post:</span>
                      <Select
                        value={kind}
                        name="kind"
                        onChange={this.handleChangeKind}
                        description="Formato do post"
                        options={[
                          { value: 'stories', text: 'Stories' },
                          { value: 'feed', text: 'Feed' },
                        ]}
                      />
                    </div>
                    <div className="field-group">
                      <span className="field-title">Tipo de conteúdo:</span>
                      <Select
                        value={content_kind}
                        name="content_kind"
                        onChange={this.handleChangeContentKind}
                        description="Tipo de conteúdo"
                        options={[
                          { value: 'image', text: 'Imagem' },
                          { value: 'video', text: 'Vídeo' },
                        ]}
                      />
                    </div>
                    <div className="field-group">
                      <span className="field-title">Evento:</span>
                      <Select
                        value={event_id}
                        name="event_id"
                        onChange={this.handleChange}
                        description="- Selecione um evento -"
                        options={events}
                      />
                    </div>
                    {kind === 'feed' && (
                      <div className="field-group">
                        <span className="field-title">Legenda:</span>
                        <TextArea
                          name="description"
                          value={description}
                          onChange={this.handleChange}
                          placeholder="Legenda"
                        />
                      </div>
                    )}
                  </div>
                  <div className="field-group upload-group">
                    <span className="field-title">Imagem da publicação:</span>
                    <span className="desc">
                      Extensões suportadas:{' '}
                      {content_kind === 'image' ? 'PNG ou JPG' : 'MP4'}
                    </span>
                    <span className="desc">
                      <strong>Tamanho ideal:</strong>{' '}
                      {kind === 'stories' ? '1080 x 1920px' : '1080 x 1080px'}
                    </span>
                    {content_kind === 'image' ? (
                      <input
                        type="file"
                        accept="image/*"
                        name="imageSrc"
                        onChange={this.onSelectImage}
                      />
                    ) : (
                      <input
                        type="file"
                        accept="video/mp4"
                        name="videoSrc"
                        onChange={this.onSelectVideo}
                      />
                    )}
                    <div className="row">
                      <div className="col-sm-6 d-none d-sm-block">
                        {imageSrc && (
                          <Fragment>
                            <span className="secondary-label">Posicione ou recorte a imagem:</span>
                            <span className="desc">
                              Clique em cima da imagem quando a posição estiver perfeita
                            </span>
                            <ReactCrop
                              src={imageSrc}
                              crop={crop}
                              onImageLoaded={this.onImageLoaded}
                              onComplete={this.onCropComplete}
                              onChange={this.onCropChange}
                            />
                          </Fragment>
                        )}
                      </div>
                      <div className="col-sm-6">
                        {croppedImageUrl && (
                          <Fragment>
                            <span className="secondary-label">Imagem cortada:</span>
                            <span className="desc">A capa aparecerá assim para os usuários</span>
                            <img alt="Crop" className="ReactCrop__result" src={croppedImageUrl} />
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <ButtonPanel>
                    <Link to="/panel/" className="btn btn-light">
                      Cancelar
                    </Link>
                    <input type="submit" className="btn btn-success" value="Criar publicação" />
                  </ButtonPanel>
                </div>
              </div>
            </form>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AddPost/index.js